// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customWidth[data-v-6520dedc]{\n  width: 270px;\n}\n", ""]);
// Exports
module.exports = exports;
